// extracted by mini-css-extract-plugin
export default {"loader":"omrHIp","rotate":"h0DJSR","inverted":"lmcWJU"};